module.exports = __webpack_public_path__ + "img/gov.1545c9c1.jpg";